import { TwilioSMSDetailsDTO } from '@hakimo-ui/hakimo/types';
import useAuthenticatedRequest from '../shared/useAuthenticatedRequest';

export function useGetTwilioSMSDetails(twilioSsid: string) {
  const url = `/v2/orm/sms/twilio/details/${twilioSsid}`;
  const request = new Request(url);

  return useAuthenticatedRequest<TwilioSMSDetailsDTO>(request, {
    queryKey: ['twilio_sms_details', twilioSsid],
    responseModifier: async (response) => {
      const respJson = await response.json();
      return respJson.payload;
    },
  });
}

export default useGetTwilioSMSDetails;
